import {useTranslation} from 'react-i18next';
import './ButtonsStyle.css';

export const CreateButton = ({onClick}) => {
    const {t} = useTranslation();
    return (
        <button className={'button--main success-button'} onClick={onClick} id={'createButton'}>
            {t('common:buttons.create')}
        </button>
    );
};
